import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { IconButtonComponent, IconComponent, IconName } from '@core/user-interface-legacy';

@Component({
  selector: 'tlc-subscription-banner',
  template: `
    <div [class]="'subscription-banner ' + type()">
      <div class="subscription-banner-content">
        @if (showIcon()) {
          <rt-icon [name]="iconName()" size="small" class="banner-icon" />
        }
        <span [innerHTML]="message()" class="banner-message"></span>
        @if (ctaLabel()) {
          <a class="banner-cta" (click)="ctaClick.emit()">{{ ctaLabel() }}</a
          ><rt-icon name="chevron-right" size="small" class="banner-cta-arrow" />
        }
        @if (isDismissible()) {
          <rt-icon-button
            (click)="dismiss.emit()"
            class="close-btn"
            size="small"
            variant="plain"
            iconName="close"
            shape="square"
          />
        }
      </div>
      <div class="banner-extra">
        <ng-content />
      </div>
    </div>
  `,
  styleUrl: './subscription-banner.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, IconButtonComponent],
})
export class TellentSubscriptionBannerComponent {
  public type = input<'normal' | 'information' | 'warning' | 'danger'>('information');
  public iconName = input<IconName>('info-outline');
  public showIcon = input(true);
  public message = input('');
  public ctaLabel = input<string | null>(null);
  public isDismissible = input(false);

  public ctaClick = output<void>();
  public dismiss = output<void>();
}
